import processSubstrateSuggestionsResponse from '../processSubstrateSuggestionsResponse';
import processFindPeopleResult from 'owa-recipient-common/lib/actions/processFindPeopleResult';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import { SubstrateSearchSuggestionsResponse } from 'owa-search-service';
import FindPeopleResponseMessage from 'owa-service/lib/contract/FindPeopleResponseMessage';
import { action } from 'satcheljs/lib/legacy';
import shouldUse3SPeopleSuggestions from 'owa-substrate-people-suggestions/lib/utils/shouldUse3SPeopleSuggestions';

export default action('processResponseResults')(function processResponseResults(
    resultList: FindRecipientPersonaType[],
    response: any,
    appendResults: boolean,
    maxResults?: number
) {
    if (shouldUse3SPeopleSuggestions()) {
        processSubstrateSuggestionsResponse(
            resultList,
            response as SubstrateSearchSuggestionsResponse,
            appendResults,
            maxResults
        );
    } else {
        processFindPeopleResult(
            resultList,
            response as FindPeopleResponseMessage,
            appendResults,
            maxResults
        );
    }
});
